import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import { Chip } from '@mui/material'
import { type AttendanceRecordStatus } from 'Pages/Attendance/types'

export type AttendanceStatusChipValue = AttendanceRecordStatus | 'Empty' | 'NotScheduled' | 'NotInSession'

const attendanceFontFamily = 'Quicksand, sans-serif'

const statusStyles: Record<AttendanceStatusChipValue, { label: string, color: string, backgroundColor: string, dot: string }> = {
  Present: { label: 'Present', color: '#1B6B88', backgroundColor: '#E6F4FA', dot: '#3694BC' },
  Tardy: { label: 'Tardy', color: '#5A2E98', backgroundColor: '#F1EAFB', dot: '#7136BC' },
  Absent: { label: 'Absent', color: '#982A43', backgroundColor: '#FBEAF0', dot: '#BC3656' },
  Empty: { label: 'Enter a status', color: '#595959', backgroundColor: '#F5F5F5', dot: '#9E9E9E' },
  NotScheduled: { label: 'Not Scheduled', color: '#595959', backgroundColor: '#F5F5F5', dot: '#9E9E9E' },
  NotInSession: { label: 'Not in session', color: '#8F8F8F', backgroundColor: '#F5F5F5', dot: '#C7C7C7' }
}

export function AttendanceStatusChip (props: {
  status: AttendanceStatusChipValue
  disabled?: boolean
  fullWidth?: boolean
  inactive?: boolean
  warning?: boolean
}): JSX.Element {
  const style = statusStyles[props.status]
  const inactive = props.inactive === true
  const warning = props.warning === true
  const borderColor = warning ? '#D08A00' : inactive ? style.dot : 'transparent'
  const defaultWidth = props.status === 'Empty' ? 124 : 108

  return (
    <Chip
      data-inactive={inactive ? 'true' : undefined}
      data-warning={warning ? 'true' : undefined}
      data-testid="attendance-status-chip"
      icon={<FiberManualRecordIcon sx={{ color: `${warning ? '#D08A00' : style.dot} !important`, height: 10, width: 10 }} />}
      label={style.label}
      size="small"
      sx={{
        backgroundColor: warning ? '#FFF6E0' : style.backgroundColor,
        border: `1px solid ${borderColor}`,
        borderRadius: '999px',
        color: warning ? '#7A4F00' : style.color,
        fontFamily: attendanceFontFamily,
        fontSize: '0.75rem',
        fontWeight: 500,
        height: 28,
        justifyContent: 'flex-start',
        minWidth: props.fullWidth === true ? 0 : defaultWidth,
        opacity: inactive ? 0.68 : props.disabled === true ? 0.8 : 1,
        width: props.fullWidth === true ? '100%' : defaultWidth,
        '& .MuiChip-label': {
          pl: 0.75,
          pr: 1
        },
        '& .MuiChip-icon': {
          ml: 1.25
        }
      }}
    />
  )
}
